// import axios from 'axios'
// import { FORM_ACTIONS } from './formValidation'
import { ACTIONS as MODAL_ACTIONS } from './modal';

import { get as getPipe } from '../utils/sigpipe';
// import SwiperCore, { Pagination, Navigation } from 'swiper/core'

export default {
  name: 'form-qualification',

  ui: {
    'btPrevStep[]': '[js-form-qualification-prev]',
    'btNextStep[]': '[js-form-qualification-next]',
    btSubmit: '[js-form-qualification-submit]',
  },

  events: [
    {
      target: 'btPrevStep',
      on: 'click',
      handle (e) {
        this.swiper.slidePrev();
      },
    },
    {
      target: 'btNextStep',
      on: 'click',
      handle (e) {
        this.swiper.slideNext();
      },
    },
  ],

  componentDidMount () {
    this.swiper = this.el.swiper;

    setTimeout(this.getModalPipe, 300);

    /* const formId = this.el.getAttribute('data-form-id')

    if (formId) {
      this.pipe = getPipe(formId)

      if (this.pipe) {
        this.pipe.on(({ action, formData }) => {
          switch (action) {
            case FORM_ACTIONS.SUBMIT: {
              console.info(
                `form ${this.pipe.id} has been submitted with these values:`,
                formData,
              )

              this.ui.btSubmit.setAttribute('disabled', 'disabled')
              const formDataNew = new FormData()
              for (const [key, value] of Object.entries(formData)) {
                formDataNew.append(key, value)
              }

              axios
                .post(this.props.route, formDataNew, {})
                .then((response) => {
                  console.log(response)
                  this.swiper.slideNext()
                })
                .error((error) => {
                  console.log(error)
                })

              break
            }

            case FORM_ACTIONS.ERROR: {
              console.warn(
                `form ${this.pipe.id} contains errors in these values:`,
                formData,
              )
              break
            }
          }
        })
      }
    } */
  },

  getModalPipe () {
    const modal = this.el.closest('[js-modal]');
    const modalPipe = getPipe(modal.getAttribute('data-pipe-id'));
    if (modalPipe) {
      modalPipe.on(({ action, emitterEl }) => {
        switch (action) {
          case MODAL_ACTIONS.OPEN: {
            const parentRow = emitterEl.closest('.row');
            if (parentRow) {
              const choice = parentRow.querySelector('input[type=radio]:checked');
              if (choice) { // if choice, preselect the same choice into the modal form and got to step 2
                this.swiper.slideTo(1, 0);
                const choiceInput = this.el.querySelector(`input[type=radio][value="${choice.value}"]`);
                choiceInput.closest('.custom-choice').click();
                choiceInput.checked = true;
              } else {
                this.swiper.slideTo(0, 0);
              }
            } else {
              this.swiper.slideTo(0, 0);
            }
            break;
          }
        }
      });
    }
  },
};
